import { QueryClient } from '@tanstack/react-query';

/**
 * Every SCIM query of one workspace sits under this prefix, then under `settings`, `tokens` or
 * `group-mappings`.
 */
export const scimQueryKey = (organizationId: string) =>
  ['scim', organizationId] as const;

/** The things a SCIM query reads, which change independently of each other. */
export type ScimQueryPart = 'settings' | 'tokens' | 'group-mappings';

/**
 * Invalidates one part of one workspace's SCIM queries: the switch moves the settings only, a token
 * created or revoked moves the list only. Nothing of another workspace is touched.
 */
export const invalidateScimQueries = (
  queryClient: QueryClient,
  organizationId: string,
  part: ScimQueryPart,
) => {
  queryClient.invalidateQueries({ queryKey: [...scimQueryKey(organizationId), part] });
};
